ui-bank-search-bank-overlay-details {
  .bank-details {
    background-color: var(--skin-color-primary-lighter, $ui-blue-minus-5);
    display: block;
    width: 100%;
    height: 100%;
    padding: $sd-spacing-6 $sd-spacing-4;

    @include breakpoint($medium) {
      padding: $sd-spacing-6 $sd-spacing-8;
    }

    @include breakpoint($desktop) {
      padding: $sd-spacing-6 $sd-spacing-4;
      padding-top: 0;
    }

    .bank-details__back-button {
      padding-bottom: $sd-spacing-6;

      sd-button::part(base) {
        padding-left: 0;
      }

      @include breakpoint($desktop) {
        position: sticky;
        top: 0;
        display: block;
        width: 100%;
        background-color: var(
          --skin-color-primary-lighter,
          $sd-backgroundColor-primary-100
        );
        z-index: 1;
      }
    }

    &__bank-name {
      display: flex;
      margin-bottom: $sd-spacing-2;
      align-items: center;

      img {
        height: 1.5rem;
        margin-right: $sd-spacing-3;
      }
    }

    &__closing-hour {
      margin-bottom: $sd-spacing-2;
    }

    &__contact {
      margin-bottom: $sd-spacing-3;

      p {
        margin-bottom: $sd-spacing-2;
      }

      &-section--title {
        display: none;

        @include breakpoint($desktop) {
          display: block;
        }
      }
    }

    &__opening-hours {
      margin-top: $sd-spacing-5;

      @include breakpoint($desktop) {
        margin-top: $sd-spacing-8;
      }

      &--title {
        display: none;

        @include breakpoint($desktop) {
          display: block;
        }
      }

      p {
        margin-bottom: $sd-spacing-2;
      }
    }

    &__directions,
    &__mobile-trigger {
      margin-bottom: $sd-spacing-6;
    }

    &__mobile-trigger {
      @include breakpoint($desktop) {
        display: none;
      }
    }

    &__mobile-toggle {
      &::part(base) {
        padding-left: 0;
      }
      @include breakpoint($desktop) {
        display: none;
      }
    }

    &__contact-section--content,
    &__opening-hours--content {
      p {
        line-height: 1.375rem;

        table {
          border-spacing: 0;
        }

        table tr td {
          &:first-child {
            padding-right: $sd-spacing-2\.5;
          }

          &:nth-child(2) {
            padding-right: $sd-spacing-8;
          }
        }
      }

      &--hide {
        display: none;

        @include breakpoint($desktop) {
          display: block;
        }
      }
    }

    &__contact-section--content {
      margin-bottom: $sd-spacing-3;

      div {
        display: flex;

        @include breakpoint($desktop) {
          justify-content: space-between;
        }
      }
    }

    &__opening-hours--content {
      margin-bottom: $sd-spacing-3;
    }

    &__info {
      display: none;

      @include breakpoint($desktop) {
        display: block;
      }

      &--active {
        display: block;
      }
    }
  }
}
